import dayjs from 'dayjs';
import Event_ from '../../models/Event';
import EventModal from "../_component/EventModal";
import lodash from 'lodash';
import { createApp, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { forms } from '../../types/front/TOrderForm';
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
const App = defineComponent({
    setup() {
        dayjs.extend(timezone);
        dayjs.extend(utc);
        dayjs.tz.setDefault("Asia/Tokyo");
        let data = ref();
        let events = reactive([new Event_()]);
        let orders = forms;
        let refForm = ref();
        let arrive_at = reactive({ year: '', month: '', day: '', value: '' });
        let event_at = { year: '', month: '', day: '', text: '' };
        onMounted(() => {
            var _a, _b;
            EventModal.onClickTabEvent();
            orders = window._.merge(orders, reactive(JSON.parse(((_a = data.value) === null || _a === void 0 ? void 0 : _a.getAttribute('orders')) || '[]')));
            events = lodash.merge(events, reactive(JSON.parse(((_b = data.value) === null || _b === void 0 ? void 0 : _b.getAttribute('events')) || '[]')));
            orders[0].plans[0].arrive_at = dayjs().add(1, 'day');
            orders[0].plans[0].pages[0].value = 8;
            orders[0].plans[0].lots[0].value = 10;
            if (events.length) {
                onClickEvent({ id: events[0].id, name: `${events[0].name}`, trend: `${events[0].trend}`, event_at: `${events[0].event_at}` }, ((events[0].subdivisions.length)
                    ? { id: events[0].subdivisions[0].id, name: `${events[0].subdivisions[0].name}`, trend: `${events[0].subdivisions[0].trend}` }
                    : undefined));
            }
        });
        watch(() => orders[0].plans[0].mode, d => {
            if (d === 'event') {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].events[0].event_at);
            }
            else {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].arrive_at);
            }
        });
        watch(() => arrive_at.value, d => {
            orders[0].plans[0].arrive_at = dayjs(d);
            //console.log(orders[0].plans[0].arrive_at);
        });
        watch(() => orders[0].plans[0].arrive_at, d => {
            arrive_at.year = dayjs(orders[0].plans[0].arrive_at).format('YYYY');
            arrive_at.month = dayjs(orders[0].plans[0].arrive_at).format('MM');
            arrive_at.day = dayjs(orders[0].plans[0].arrive_at).format('DD');
            orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
        });
        watch(() => orders[0].plans[0].events[0].event_at, d => {
            event_at.year = dayjs(orders[0].plans[0].events[0].event_at).format('YYYY');
            event_at.month = dayjs(orders[0].plans[0].events[0].event_at).format('MM');
            event_at.day = dayjs(orders[0].plans[0].events[0].event_at).format('DD');
            event_at.text = dayjs(orders[0].plans[0].events[0].event_at).format('YYYY.MM.DD');
            orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
        });
        const onClickEvent = (event, subdivision) => {
            orders[0].plans[0].events[0].id = event.id;
            orders[0].plans[0].events[0].name = event.name;
            orders[0].plans[0].events[0].trend = event.trend;
            orders[0].plans[0].events[0].event_at = dayjs(event.event_at);
            if (subdivision) {
                orders[0].plans[0].events[0].subdivisions[0].id = subdivision.id;
                orders[0].plans[0].events[0].subdivisions[0].name = subdivision.name;
                orders[0].plans[0].events[0].subdivisions[0].trend = subdivision.trend;
            }
            else {
                orders[0].plans[0].events[0].subdivisions[0].id = null;
                orders[0].plans[0].events[0].subdivisions[0].name = null;
                orders[0].plans[0].events[0].subdivisions[0].trend = null;
            }
        };
        const onClickContractor = (id, name) => {
            orders[0].plans[0].contractors[0].id = id;
            orders[0].plans[0].contractors[0].trade_name = name;
        };
        const onClickPage = (value) => {
            orders[0].plans[0].pages[0].value = value;
        };
        const onClickLot = (value) => {
            orders[0].plans[0].lots[0].value = value;
            orders[0].plans[0].forwardings[0].lot = value;
        };
        const onClickRequiredCheckbox = (event) => {
            let e = event.target;
            let target = document.querySelectorAll(`[data-group="${e.getAttribute('data-group')}"]`);
            if (Array.prototype.filter.call(target, node => { return node.checked == true; }).length < 1) {
                e.checked = true;
            }
        };
        return {
            arrive_at,
            event_at,
            data,
            orders,
            refForm,
            onClickRequiredCheckbox,
            onClickEvent,
            onClickContractor,
            onClickPage,
            onClickLot,
        };
    }
});
window.addEventListener('DOMContentLoaded', (ev) => {
    createApp(App).mount('#app');
});
